import React, { useEffect } from "react";
import "./Chants.css";
import Common_Title_3 from "../../common/common_components/Common_Title_3/Common_Title_3";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import Music_option_modal from "../../common/modals/music-option-modal/Music_option_modal";
import Music_play_modal from "../../common/modals/music-play-modal/Music_play_modal";
import Music_card from "../../common/common_components/music-card/Music_card";
import { useDispatch, useSelector } from "react-redux";
import { AllChants, GurujiWisdom } from "../../../features/admin/common/Slice";

const Chants = () => {

  const [modalShow, setModalShow] = React.useState(false);
  const [modalShow2, setModalShow2] = React.useState(false);

  const dispatch = useDispatch();
  const chants = useSelector((state) => state.common.all_chants);


  useEffect(() => {
    dispatch(AllChants({ chant_type_id: null }));
  }, [dispatch])

  return (
    <section className="Chants">
      <div className="container">
        <Common_Title_3 titleText="Om Tapovan Chants" seelink={'/all-albums'} />

        <div className="swiper_div">
          <Swiper
            autoplay={{
              delay: 2000,
              disableOnInteraction: false,
            }}
            modules={[Pagination, Autoplay]}
            className="orange_pagination_swiper"
            // navigation={true}
            spaceBetween={16}
            slidesPerView={2}
            pagination={{ clickable: true }}
            breakpoints={{
              0: { slidesPerView: 1.2 },
              380: { slidesPerView: 1.7 },
              576: { slidesPerView: 1.5 },
              768: { slidesPerView: 2 },
              992: { slidesPerView: 2.5 },
              1200: { slidesPerView: 3.2 },
            }}
          >
            {chants?.map((chant, index) => {
              return (
                <SwiperSlide key={index}>
                  <Music_card music={chant} musicList={chants} />
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </div>

      <Music_option_modal
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
      <Music_play_modal
        show={modalShow2}
        onHide={() => setModalShow2(false)}
      />
    </section>
  );
};

export default Chants;
